/**
 * HTTP请求
 * @param provide:传递的参数
 * @param Success：自定义回掉成功
 * @param Error：自动义回掉失败xxw
 * @param style: 代开发( 支持多种api请求  )
 * Config = {
              // 接口
              url: {
                  type: String,
                  required: true
              },
              // 方法
              method: {
                  type: String,
                  default: 'GET'
                  required: true
              },
              // 接口参数配置
              body: {
                  type: Object,
                  default: {}
              },
              // 请求模式 (fetch / 钉钉 ／ 微信 ／axios)
              mode: {
                  type: [axios, fetch, dd, weixin], // 排列顺序-满足条件
                  default: 'axios'
              },
              // 完成的回调
              done: {
                  type: Function
              }
          }
 **/
import axios from 'axios';

export default function (provide = {}, Success = function () {
}, Error = function () {
}) {
  // 默认使用axios
  // dd = test 测试环境  dd = online 聚塔石环境
  let dd = process.env.DD || false;
  let Mode = '';
  if (dd == 'online') {
    Mode = 'dd';
  } else if (dd == 'test') {
    Mode = 'fetch';
  } else {
    Mode = provide.mode || 'axios';
  }
  return defaultResult['_' + Mode](provide);
}

const defaultResult = {
  /**
   * 重置,服务端协议
   *  @param code: 错误码
   *  @param desc: 错误描述
   *  @param data: 正文
   */
  result: {},
  _dd(provide) {
  },
  _axios(provide) {
    let options = {
      mode: 'include'
    };
    let {body, method, ...opt} = provide;
    if (method == 'GET') {
      if (opt.url.indexOf('?') === -1) {
        opt.url = `${opt.url}?t=${Date.now()}`;
      } else {
        opt.url = `${opt.url}&t=${Date.now()}`;
      }
      options = {params: body, method, ...opt};
    } else {
      options = {data: body, method, ...opt};
    }
    return axios(options).then(
      (response) => {
        let responseData = response.data;
        return this.success(provide, responseData);
      }, (response) => {
        return this.error(provide, response);
      }
    );
  },
  _fetch(provide) {
    let options = {
      mode: 'cors', // cors(cors) / no-cors(opaque) / same-origin(basic)
      credentials: 'include', // include: 跨域下带cook  // same-origin: 同源, 表示同域请求才发送cookie.
      headers: {
        'Content-Type': 'application/json'
      }
      // cache: 'default' // 缓存
      // 不支持jsonp请求  fetch-jsonp 解决
      // 没有 timeout 机制
      // 没有 progress 提示
      // 不支持原生的abort机制
    };
    let {url, body, method, ...opt} = provide;
    if (method == 'POST') {
      options = {body: JSON.stringify(body), method, ...opt, ...options};
    } else if (method == 'GET') {
      const str = Object.keys(body).map(key => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(body[key]);
      }).join('&');
      url = url + '?' + str;
      options = {method, ...opt, ...options};
    }
    return fetch(url, options)
    .then(response => response.json())
    .then(
      (responseData) => {
        return this.success(provide, responseData);
      }, (response) => {
        return this.error(provide, response);
      }
    );
  },
  // 成功回调
  success(provide, responseData) {
    this.result = {};
    if (responseData.errCode === 0) {
      Object.assign(this.result, {
        data: responseData.data,
        msg: responseData.msg
      });
    } else {
      Object.assign(this.result, {
        // desc: '接口:' + provide.url + '  原因：' + responseData.msg,
        desc: responseData.msg,
        code: responseData.errCode
      });
    }
    return this.result;
  },
  // 失败回调
  error(provide, error) {
    this.result = {};
    Object.assign(this.result, {
      // desc: `获取数据模型失败，接口: ${provide.url} -  原因：${error} - 状态：${error.response.status} - 请刷新`
      desc: `获取数据模型失败`
    });
    return this.result;
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/core/response.js